import { render, staticRenderFns } from "./SecondSponsorsByAirTime.vue?vue&type=template&id=57e9dd28&"
import script from "./SecondSponsorsByAirTime.vue?vue&type=script&lang=js&"
export * from "./SecondSponsorsByAirTime.vue?vue&type=script&lang=js&"
import style0 from "./SecondSponsorsByAirTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports